import React, { useState } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import AudienceHero from '../../components/AudienceHero';
import ApexSixMethod from '../../components/ApexSixMethod';
import FAQSection from '../../components/FAQSection';
import FinalCTABanner from '../../components/FinalCTABanner';
import PrivacyPolicy from '../../components/PrivacyPolicy';
import { CALENDLY_URL, LOGO_URL, INSTAGRAM_URL } from '../../lib/siteConfig';

/**
 * /method — full deep-dive into the Apex Six framework. The homepage now
 * shows a compact preview (`ApexSixPreview`); this page owns the depth.
 */
export default function MethodPage() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="method-page">
      <Navbar calendlyLink={CALENDLY_URL} logoUrl={LOGO_URL} />
      <main>
        <AudienceHero
          testIdPrefix="method-hero"
          eyebrow="The Method"
          headline="The Apex Six. Six protocols. One playbook."
          subhead="Every package, workshop, and AI Coach interaction sits on top of the same framework. Below is the full breakdown: when to use each protocol, what it teaches, and how it shows up in practice."
          primaryCta={{ href: '/assessment', label: 'Find Your Primary Action — $27 IDP' }}
          secondaryCta={{ href: CALENDLY_URL, label: 'Book a Discovery Call', external: true }}
        />

        <ApexSixMethod calendlyLink={CALENDLY_URL} />
        <FAQSection />

        <FinalCTABanner
          primaryHref={CALENDLY_URL}
          primaryLabel="Book a Discovery Call"
          secondaryHref="/assessment"
          secondaryLabel="Take the $27 Self-Assessment"
        />
      </main>
      <Footer
        calendlyLink={CALENDLY_URL}
        instagramLink={INSTAGRAM_URL}
        logoUrl={LOGO_URL}
        onPrivacyClick={() => setPrivacyOpen(true)}
      />
      <PrivacyPolicy open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
    </div>
  );
}
